



















































import {InitiatorClass} from '@/types/InitiatorClass';
import {InitiatorApi} from '@/api/initiator-api';
import Initiator from '@/components/Initiator.vue';
import Vue from 'vue';
import {UserApi} from '@/api/user-api';
import {RoutsData} from '@/router/routs';
import {UserRole} from '@/types/user-role';

export default Vue.extend({
  name: 'InitiatorList',
  components: {Initiator},
  beforeMount() {
    this.getData();
  },
  data() {
    return {
      initiators: [] as InitiatorClass[],
      showAddDialog: false,
      users: [] as { text: string, value: string }[]
    };
  },
  methods: {
    getData() {
      InitiatorApi.getList().then(res => this.initiators = res.data);
      UserApi.getList().then(res => this.users = res.data.filter(u => u.role == UserRole.USER).map(i => ({text: i.login, value: i.id})));
    },
    deleteUser(index: number) {
      const initiator = this.initiators.splice(index, 1);
      InitiatorApi.delete(initiator[0].id);
    },
    async add(data: InitiatorClass) {
      await this.save(data);
      this.showAddDialog = false;
      this.getData();
    },
    save(data: InitiatorClass) {
      return InitiatorApi.save(data);
    },
    edit(ind: number) {
      InitiatorApi.edit(this.initiators[ind].id, this.initiators[ind]);
    }
  }
});
